// removed by extract-text-webpack-plugin
module.exports = {"breadCrumb":"BreadCrumb-breadCrumb-d8e035a2","icon":"BreadCrumb-icon-8fc49f32"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/BreadCrumb.scss
// module id = 841
// module chunks = 0